import React from "react";
import {
  CompletedBadge,
  CorrectionBadge,
  DeletedBadge,
  DeletingBadge,
  DraftBadge,
  NewBadge,
  QueryableBadge,
  RunningBadge,
  StoppedBadge,
} from "../../core/views/Badges";
import { SupportedFeatureSwitch } from "../../core/views/SupportedFeatureSwitch";
import { ExecutionState, isCompletedExecutionState } from "../../core/api/contracts/ExecutionState";
import { ItemStatusClazz } from "../../core/api/contracts/ItemStatus";
import { observer } from "mobx-react";

export const statusBadge: Record<ItemStatusClazz, any> = {
  New: <NewBadge />,
  Draft: <DraftBadge />,
  Stopped: <StoppedBadge />,
  Running: <RunningBadge />,
  Archived: <DeletedBadge />,
  Deleting: <DeletingBadge />,
  Queryable: <QueryableBadge />,
  Completed: <CompletedBadge />,
  Correction: <CorrectionBadge />,
};

export const TemplateStateBadge = observer(
  ({
    template,
  }: {
    template: {
      completed?: boolean;
      isCompleted?: boolean;
      executionState?: ExecutionState;
      status: { clazz: string };
    };
  }) => {
    const status = template.status.clazz;
    if (
      (status === "Running" || status === "Completed") &&
      (template.completed || template.isCompleted || isCompletedExecutionState(template.executionState))
    ) {
      return <CompletedBadge />;
    } else {
      return <>{statusBadge[status as ItemStatusClazz]}</>;
    }
  }
);

export const OptionalItemsCount = ({ count }: { count: number }) =>
  count > 0 ? <span>{`(${count})`}</span> : <span />;

export const optionalItemsCount = (count: number) => (count > 0 ? `(${count})` : "");

export const ArchiveText = () => (
  <SupportedFeatureSwitch feature={"new-deletion"} fallback={"Archive"}>
    Delete
  </SupportedFeatureSwitch>
);
